export default "__VITE_ASSET__39ba6e3c__"